export default __webpack_public_path__ + "static/media/Guru-Parampara-06.8089213c.png";